export default "__VITE_ASSET__DxKhG5yk__"